import logoImg from '../assets/logo_transparent.svg'

export const Logo = ({ size }: { size: number}): JSX.Element => (
    <img width={size}
    height={size} src={logoImg}/>
)
